var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsReleaseNotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-1424 -431)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 16,
    height: 16,
    transform: "translate(1424 431)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ico-report-1",
    transform: "translate(1426 432)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 12.72,
    height: 14.63,
    fill: "#c6cacc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M17.625,5.88V5.819L15.351,3.183h-.028v.009H9.072V14.958h8.543l.012-8.149H18.7v8.139A1.174,1.174,0,0,1,17.622,16.2H8.936A1.019,1.019,0,0,1,8,15.112V3.037a1.019,1.019,0,0,1,.936-1.084h6.386V1.944h.085a.87.87,0,0,1,.662.318l2.351,2.725a1.17,1.17,0,0,1,.274.767v.128ZM15.07,8.841l-.122.393-.657-2.34a.387.387,0,0,0-.763,0l-.943,3.378-.466-1.439a.407.407,0,0,0-.375-.3H10.407V9.46h1.059l.772,2.382a.407.407,0,0,0,.375.3h.01A.413.413,0,0,0,13,11.822l.917-3.284.638,2.276a.386.386,0,0,0,.758.011L15.73,9.46h.824V8.533H15.447a.408.408,0,0,0-.377.307Z",
    transform: "translate(-6.903 -1.677)",
    fill: "#c6cacc"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsReleaseNotes);
export default __webpack_public_path__ + "static/media/icons-release-notes.60a088d3.svg";
export { ForwardRef as ReactComponent };